"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MVPicker = void 0;
const tslib_1 = require("tslib");
const Utilities_1 = require("../../../javascript/Utilities");
const PropertyPageControls_1 = require("../PropertyPageControls");
const ExternalInput_1 = require("./ExternalInput");
const Base_1 = require("../../../model/Base");
const _ = require("underscore");
/**
* Multivalue picker
*/
class MVPicker extends ExternalInput_1.ExternalInput {
    constructor(controlColl, currentInstance, methodName = undefined) {
        super(controlColl, currentInstance, methodName);
        this.methodName = methodName;
        /**
         * Counter for how often it was attempted to fetch a value
        */
        this.numAttempts = 0;
        this.windowContentCssClass = "eiMVPicker";
        this.windowWidth = 470;
        this.windowHeight = 280;
        this.windowResizeable = true;
        this.isFTRepresentativeField = this.input.field.isFTRepresentativeField;
        this.hasMethodButton = this.controlColl.Button.methodButtonForMVDialog != undefined;
    }
    initWindowContents() {
        const that = this;
        const idData = {
            synUtil: Utilities_1.synUtil
        };
        $.each([
            "itemsCell",
            "itemsList",
            "listMethodButtonPane",
            "upButton",
            "downButton",
            "ftEntryCell",
            "methodButtonCell",
            "addButton",
            "replaceButton",
            "delButton"
        ], function (idx, id) {
            idData[id] = id + "_" + that.windowData.guid;
        });
        idData.readonly = that.input.readonlyForExtInput;
        const mvMarkup = require("../../../templates/externalInputs/MVFTPicker.tmpl.html");
        const template = kendo.template(mvMarkup);
        const result = template(idData);
        that.widgetContainer.html(result);
        if (that.mode !== Base_1.PropertyPageMode.View && !that.input.readonlyForExtInput)
            that.createPickerControl(idData);
        that.createMethodButtonForList(idData);
        that.createGrid(idData);
        if (that.mode !== Base_1.PropertyPageMode.View && !that.input.readonlyForExtInput)
            $("#" + idData.itemsList).css("height", "183px");
        else
            $("#" + idData.itemsList).css("height", "260px");
        if (that.mode === Base_1.PropertyPageMode.View || that.input.readonlyForExtInput) {
            $.each(["upButton", "downButton", "addButton", "replaceButton", "delButton", "ftEntryCell", "methodButtonCell",], function (idx, id) {
                $("#" + idData[id]).css("display", "none");
            });
        }
        else
            that.registerButtons(idData);
        return Promise.resolve();
    }
    getUpdatedInstance() {
        const that = this;
        const updatedInstance = that.currentInstance;
        if (that.mode !== Base_1.PropertyPageMode.View && !that.input.readonlyForExtInput) {
            const data = that.gridView.dataSource.view();
            const presentedArr = [], representativeArr = [];
            $.each(data, function (idx, entry) {
                let ishardDeleted = false;
                if (that.input.initialValue && that.input.initialFTEntries.hardDeletedEntries && that.input.initialFTEntries.hardDeletedEntries.length > 0) {
                    const hardDeletedEntries = that.input.initialFTEntries.hardDeletedEntries;
                    let delId;
                    for (let i = -1, len = hardDeletedEntries.length; ++i < len;) {
                        delId = hardDeletedEntries[i];
                        if (entry.id === delId)
                            ishardDeleted = true;
                    }
                }
                if (!ishardDeleted)
                    representativeArr.push(that.pickerControl.convertBack(entry.value, true)); // innerValue=true, da ansonsten ein array in einem array erzeugt wird!
                presentedArr.push(entry.id);
            });
            updatedInstance.items[that.input.field.fieldName].value = representativeArr;
            if (that.isFTRepresentativeField)
                updatedInstance.items[that.input.field.presentedField].value = presentedArr;
        }
        return Promise.resolve(updatedInstance);
    }
    destroyWidgets() {
        if (this.pickerControl)
            this.pickerControl.destroy();
        this.gridView.destroy();
    }
    //#region Private functions
    createPickerControl(idData) {
        const that = this;
        if (that.input.enabled) {
            const propPageContainer = $("#" + idData.ftEntryCell);
            const fac = new PropertyPageControls_1.ControlFactory(propPageContainer, that.currentInstance, that.typeId, that.mode, undefined, {}, undefined);
            let controlType = "FTComboBoxInfo";
            switch (that.input.field.fieldType) {
                case "String":
                case "FixString":
                    if (!that.isFTRepresentativeField)
                        controlType = "TextBoxInfo";
                    break;
                case "Digit":
                case "BigDigit":
                    if (!that.isFTRepresentativeField)
                        controlType = "NumericTextBoxInfo";
                    break;
                case "Float":
                    controlType = "NumericTextBoxInfo";
                    break;
                case "Date":
                    controlType = "DateCtrlInfo";
                    break;
                case "Time":
                    controlType = "TimeCtrlInfo";
                    break;
                case "DateTime":
                    controlType = "DateAndTimeCtrlInfo";
                    break;
            }
            const copyControl = $.extend(true, {}, that.input);
            fac.pushControl({
                type: controlType,
                enabled: true,
                visible: true,
                key: that.controlKey,
                width: 0,
                height: 22,
                tabOrder: 0,
                field: copyControl.field,
                maxTextLength: copyControl.maxTextLength,
                readonly: false,
                initialValue: undefined,
                formatString: copyControl.formatString,
                forExternalInput: true,
            });
            if (that.hasMethodButton) {
                const methodButton = $.extend(true, {}, that.controlColl.Button.methodButtonForMVDialog);
                methodButton.desiredHeight = "20px";
                methodButton.desiredWidth = "20px";
                fac.pushControl(methodButton);
            }
            const lookUp = fac.create();
            that.pickerControl = lookUp.controlsByFieldName[that.input.field.fieldName].Input;
            if (that.pickerControl instanceof PropertyPageControls_1.TextBoxControl || that.pickerControl instanceof PropertyPageControls_1.NumericTextBoxControl) {
                that.pickerControl.getDOMControl().keyup(function (e) {
                    if (e.keyCode === 13)
                        that.addValue(that);
                });
            }
            const pickerDOM = that.pickerControl.getDOMControl();
            if (that.hasMethodButton) {
                that.methodButton = lookUp.controlsByFieldName[that.input.field.fieldName].Button;
                that.methodButton.overrideCurrentInstanceFunc = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
                    return yield that.getUpdatedInstance();
                });
                if (that.pickerControl.type === "FTComboBoxInfo") {
                    that.methodButton.overrideCurrentInstanceIdFuncFTOL = (method, field, docIdCallback) => {
                        let docId;
                        if (field.isFTField) {
                            const id = that.pickerControl.getIdString();
                            if (method.field.length > 0) {
                                const ftData = { requestedIds: [id] };
                                Utilities_1.synUtil.getAJAXData({
                                    method: "POST",
                                    url: Utilities_1.synUtil.getWSUrl("ForeigntableEntries") + field.foreignTableName + "/",
                                    requestData: JSON.stringify(ftData),
                                    done(data) {
                                        docId = data.items[0][method.field];
                                        docIdCallback(docId);
                                    },
                                    fail(jqXHR, textStatus, errorThrown, url) {
                                        Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
                                    }
                                });
                            }
                            else {
                                docId = id;
                                docIdCallback(docId);
                            }
                        }
                    };
                }
                that.methodButton.overrideExternalInputCallBack = (cancelled, changedInstance) => {
                    if (!cancelled) {
                        that.createGridDataSource(changedInstance, (kendoDataSource) => {
                            that.gridView.setDataSource(kendoDataSource);
                        });
                    }
                };
                // Hinweis: Wenn der Dialog in der Größe verändert wird, muss sichergestellt werden, dass das Input-Control in der Breite wächst und der Button in seiner Breite konstant bleibt
                propPageContainer.css({
                    "display": "flex",
                    "flex-direction": "row"
                });
                const parentHeight = propPageContainer.height();
                let buttonWidth = parentHeight;
                if (that.methodButton.methods.length > 1)
                    buttonWidth = parentHeight * 2;
                const methodButtomDOM = that.methodButton.getDOMControl()
                    .css({
                    "width": buttonWidth + "px",
                    "height": parentHeight + "px",
                    "box-sizing": "border-box",
                });
                pickerDOM.css({
                    "flex-grow": "1"
                });
            }
            else
                pickerDOM.css("width", "100%");
        }
    }
    createMethodButtonForList(idData) {
        const that = this;
        if (that.hasMethodButton) {
            const listFac = new PropertyPageControls_1.ControlFactory($("#" + idData.listMethodButtonPane), that.currentInstance, that.typeId, that.mode, undefined, {}, undefined);
            if (that.controlColl.Button.field.isFTOLMethodReferenced) {
                const methodButtonForList = $.extend(true, {}, that.controlColl.Button.methodButtonForMVDialog);
                methodButtonForList.desiredHeight = "20px";
                methodButtonForList.desiredWidth = "20px";
                listFac.pushControl(methodButtonForList);
                const listLookUp = listFac.create();
                that.listMethodButton = listLookUp.controlsByFieldName[that.input.field.fieldName].Button;
            }
            if (that.listMethodButton != undefined) {
                that.listMethodButton.overrideCurrentInstanceIdFuncFTOL = (method, field, docIdCallback) => {
                    if (that.gridView.select().length === 1) {
                        let docId;
                        if (field.isFTField) {
                            const id = that.gridView.dataItem(that.gridView.select()).id;
                            if (method.field.length > 0) {
                                const ftData = { requestedIds: [id] };
                                Utilities_1.synUtil.getAJAXData({
                                    method: "POST",
                                    url: Utilities_1.synUtil.getWSUrl("ForeigntableEntries") + field.foreignTableName + "/",
                                    requestData: JSON.stringify(ftData),
                                    done(data) {
                                        docId = data.items[0][method.field];
                                        docIdCallback(docId);
                                    },
                                    fail(jqXHR, textStatus, errorThrown, url) {
                                        Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
                                    }
                                });
                            }
                            else {
                                docId = id;
                                docIdCallback(docId);
                            }
                        }
                        else {
                            docId = that.gridView.dataItem(that.gridView.select()).value;
                            docIdCallback(docId);
                        }
                    }
                    return undefined;
                };
                const parentHeight = $("#" + idData.listMethodButtonPane).height();
                let buttonWidth = parentHeight;
                if (that.listMethodButton.methods.length > 1)
                    buttonWidth = parentHeight * 2;
                that.listMethodButton.getDOMControl().css({
                    "width": buttonWidth + "px",
                    "height": parentHeight + "px",
                    "box-sizing": "border-box",
                    "display": "inline-block",
                    "margin-top": "0px" // Hinweis: margin-top wird an dieser Stelle nur gesetzt, weil vom css irgendwoher ein 2px margin kommt, der stört --> MVPicker-Dialog gehört grundsätzlich überarbeitet!
                });
            }
        }
    }
    createGridDataSource(instance, done) {
        const that = this;
        const currentData = [];
        const repVal = instance.items[that.input.field.fieldName].valueAsArray;
        if (that.isFTRepresentativeField) {
            const presVal = instance.items[that.input.field.presentedField].valueAsArray;
            if (repVal.length !== presVal.length) { /* Hard Deleted Fields */
                const hardDeletedEntries = instance.ftEntries[that.input.field.fieldName].hardDeletedEntries;
                let delId, delIdIdx;
                if (hardDeletedEntries) {
                    for (let i = -1, len = hardDeletedEntries.length; ++i < len;) {
                        delId = hardDeletedEntries[i];
                        delIdIdx = _.indexOf(presVal, delId);
                        if (delIdIdx >= 0)
                            repVal.splice(delIdIdx, 0, kendo.format(Utilities_1.synUtil.Strings.getValue("dynpftentryharddeletedid").replace('%s', '{0}'), delId));
                    }
                }
            }
            const softDeletedEntries = instance.ftEntries[that.input.field.fieldName].softDeletedEntries;
            const softDeletedWarningEntries = instance.ftEntries[that.input.field.fieldName].softDeletedWarningEntries;
            const abstractEntries = instance.ftEntries[that.input.field.fieldName].abstractEntries;
            for (let i = 0; i < presVal.length; i++) {
                const softDeletedEntriesIDs = _.pluck(softDeletedEntries, 'id');
                const softDeleted = _.indexOf(softDeletedEntriesIDs, presVal[i]) !== -1 && _.indexOf(softDeletedWarningEntries, presVal[i]) !== -1;
                const abstractEntriesIDs = _.pluck(abstractEntries, 'id');
                const abstract = _.indexOf(abstractEntriesIDs, presVal[i]) !== -1;
                currentData.push({ id: presVal[i], value: that.input.convert(repVal[i], true), softDeleted, abstract });
            }
            const requestData = {
                fieldName: that.input.field.fieldName,
                instanceData: JSON.stringify(instance.toJSON()),
                ids: JSON.stringify(presVal)
            };
            if ((that.input.field.fieldConstraint & 32768) && presVal.length) {
                const ftIconUrl = Utilities_1.synUtil.getWSUrl("PropertypageFTEntryIcons");
                Utilities_1.synUtil.getAJAXData({
                    method: "POST",
                    url: ftIconUrl,
                    requestData: JSON.stringify(requestData),
                    done(iconMap) {
                        $.each(currentData, (idx, obj) => {
                            if (iconMap[obj.id])
                                obj.ceimage = iconMap[obj.id];
                        });
                        done(new kendo.data.DataSource({ data: currentData }));
                    }
                });
            }
            else
                done(new kendo.data.DataSource({ data: currentData }));
        }
        else {
            for (let i = 0; i < repVal.length; i++) {
                const str = this.input.convert(repVal[i], true);
                const dataobj = { id: str, value: str };
                currentData.push(dataobj);
            }
            done(new kendo.data.DataSource({ data: currentData }));
        }
    }
    createGrid(idData) {
        const that = this;
        const template = "# let ftIcon = ''; \
                          let divClasses = ''; \
                          if(data.softDeleted) \
                              divClasses += ' ppFtSoftDeletedEntry';\
                          if(data.isAbstract) \
                              divClasses += ' ppFtAbstractEntry';\
                          if(data.ceimage) \
                              ftIcon = '<img class=\\'ppFtIcon ppMvPickerIcon\\' alt=\\'\\' src=\\'" + Utilities_1.synUtil.getWSUrl('Icon') + "' + data.ceimage + '/16' +'\\' />'; \
           return '<tr data-uid=\\'' + data.uid + '\\'><td role=\\'gridcell\\'><div class=\\' ' + divClasses + '\\'>' + ftIcon + kendo.htmlEncode(value) + '</div></td></tr>';#";
        that.createGridDataSource(that.currentInstance, (kendoDataSource) => {
            that.gridView = $("#" + idData.itemsList)
                .css("width", $("#" + idData.itemsCell).innerWidth() + "px")
                .css("height", $("#" + idData.itemsCell).innerHeight() + "px")
                .kendoGrid({
                rowTemplate: template,
                selectable: "single",
                columns: [{
                        field: "value",
                        title: this.title,
                        sortable: {
                            compare(a, b) {
                                const va = that.input.convertBack(a.value, true), vb = that.input.convertBack(b.value, true);
                                if (va < vb)
                                    return -1;
                                else if (va > vb)
                                    return 1;
                                return 0;
                            }
                        }
                    }],
                sortable: true,
                dataSource: kendoDataSource
            }).data("kendoGrid");
            window.setTimeout(function () { that.gridView.dataSource.read(); }, 50);
        });
    }
    getPickerValue(that) {
        if (that.pickerControl instanceof PropertyPageControls_1.FTComboBoxControl) {
            const combo = that.pickerControl;
            const id = combo.getIdString();
            if (!id)
                return undefined;
            return {
                id,
                value: that.pickerControl.getValueString(),
                ceimage: combo.getIcon()
            };
        }
        return that.pickerControl.getValue();
    }
    clearPickerValue(that) {
        if (that.pickerControl instanceof PropertyPageControls_1.FTComboBoxControl) {
            const combo = that.pickerControl;
            combo.setValueString("");
            combo.notifyChange();
        }
        else
            that.pickerControl.setValue("");
    }
    addValue(that) {
        const val = that.getPickerValue(that);
        if (!val && val !== 0)
            return;
        if (val.id === "<ADDITEM>") {
            // Try again after timeout
            if (that.numAttempts < 50) {
                that.numAttempts++;
                window.setTimeout(() => { that.addValue(that); }, 200);
            }
            else
                that.numAttempts = 0;
        }
        else if (val || val === 0) {
            that.numAttempts = 0;
            if (that.isFTRepresentativeField) {
                if (val.id && that.listIndexOfValue(val) < 0)
                    that.gridView.dataSource.add(val);
            }
            else {
                const valString = that.pickerControl.convert(val, true);
                if (that.listIndexOfValue(valString) < 0)
                    that.gridView.dataSource.add({ id: valString, value: valString });
            }
            that.clearPickerValue(that);
            that.pickerControl.setFocus();
        }
        else
            that.numAttempts = 0;
    }
    selectGridElem(index) {
        const that = this;
        const domElem = that.gridView.content.find("tr:eq(" + index + ")");
        that.gridView.select(domElem);
    }
    registerButtons(idData) {
        const that = this;
        //#region Add button
        $("#" + idData.addButton).on("click", function () {
            that.addValue(that);
        });
        //#endregion Add button
        const ensureChildDependentFieldsAreEmpty = () => {
            let childFieldsEmpty = true;
            const coll = that.input.controlFactory.controlCollection;
            const presentedField = that.input.field.isFTRepresentativeField ? that.input.field.presentedField : that.input.field.fieldName;
            const filledFieldCaptions = [];
            if (that.input.childControls.length) {
                $.each(that.input.childControls, (i, c) => {
                    const fieldName = c.field.isFTRepresentativeField ? c.field.presentedField : c.field.fieldName;
                    if (fieldName === presentedField || !c.field.multiValue)
                        return true;
                    const childVal = that.currentInstance.items[fieldName].valueAsArray;
                    if (childVal.length !== 0) {
                        let fieldCaption = fieldName;
                        const controlsForField = coll.controlsByFieldName[c.field.fieldName];
                        if (controlsForField && controlsForField.Input && controlsForField.Input.field.fieldTitle)
                            fieldCaption = controlsForField.Input.field.fieldTitle;
                        filledFieldCaptions.push(fieldCaption);
                        childFieldsEmpty = false;
                    }
                });
            }
            if (!childFieldsEmpty) {
                let msg = Utilities_1.synUtil.Strings.getValue("dynpmultivdlgdelreplace", "It is not allowed to delete or replace items because the following dependent fields are filled:");
                msg += "\n\n" + filledFieldCaptions.join("\n");
                Utilities_1.synUtil.Notifications.error(msg);
            }
            return childFieldsEmpty;
        };
        //#region Delete button
        $("#" + idData.delButton).on("click", function () {
            if (ensureChildDependentFieldsAreEmpty()) {
                const idx = that.gridView.select().index();
                if (idx >= 0) {
                    that.gridView.dataSource.remove(that.gridView.dataSource.view()[idx]);
                    const countItems = that.gridView.dataSource.data().length;
                    if (countItems > 0) {
                        const selIdx = Math.min(Math.max(idx, 0), countItems - 1);
                        that.selectGridElem(selIdx);
                    }
                }
            }
        });
        //#endregion Delete button
        //#region Replace button
        $("#" + idData.replaceButton).on("click", function () {
            const val = that.getPickerValue(that);
            if (!val)
                return;
            if (val.id === "<ADDITEM>") {
                // Try again after timeout
                if (that.numAttempts < 50) {
                    that.numAttempts++;
                    window.setTimeout(() => { $("#" + idData.replaceButton).trigger("click"); }, 200);
                }
                else
                    that.numAttempts = 0;
            }
            else if (val && ensureChildDependentFieldsAreEmpty()) {
                that.numAttempts = 0;
                if (that.isFTRepresentativeField) {
                    const listIdx = that.gridView.select().index();
                    if (listIdx >= 0) {
                        const idx = that.listIndexOfValue(val);
                        if (val.id && idx < 0) {
                            const a = that.gridView.dataSource.view()[listIdx];
                            that.gridView.dataSource.remove(a);
                            that.gridView.dataSource.insert(listIdx, val);
                        }
                    }
                }
                else {
                    const listIdx = that.gridView.select().index();
                    if (listIdx >= 0) {
                        const valString = that.pickerControl.convert(val, true);
                        const idx = that.listIndexOfValue(valString);
                        if (idx < 0) {
                            const a = that.gridView.dataSource.view()[listIdx];
                            that.gridView.dataSource.remove(a);
                            that.gridView.dataSource.insert(listIdx, { id: valString, value: valString });
                        }
                    }
                }
            }
            else
                that.numAttempts = 0;
        });
        //#endregion Replace button
        //#region Reorder buttons (up, down)
        $(".repositionButton").on("click", function () {
            const selItem = that.gridView.select();
            if (selItem.length) {
                const up = $(this).attr("data-repositiondirection") === "up";
                const dataItem = that.gridView.dataItem(selItem);
                const val = dataItem.value;
                const selIdx = that.listIndexOfValue((that.isFTRepresentativeField ? dataItem : val));
                const inRange = up ? (selIdx > 0) : (selIdx < that.gridView.dataSource.data().length - 1);
                if (inRange) {
                    const currentOrder = that.gridView.dataSource.view();
                    that.gridView.dataSource.data([]);
                    that.gridView.dataSource.sort([]);
                    $.each(currentOrder, (idx, elem) => {
                        that.gridView.dataSource.data($.map(currentOrder, (item) => {
                            return { id: item.id, value: item.value, softDeleted: item.softDeleted, isAbstract: item.isAbstract };
                        }));
                    });
                    const newIdx = up ? selIdx - 1 : selIdx + 1;
                    const item = that.gridView.dataSource.view()[selIdx];
                    that.gridView.dataSource.remove(item);
                    that.gridView.dataSource.insert(newIdx, item);
                    that.selectGridElem(newIdx);
                }
            }
        });
        //#endregion Reorder buttons (up, down)
    }
    listIndexOfValue(value) {
        if (this.isFTRepresentativeField)
            return this.gridView.dataSource.indexOf(this.gridView.dataSource.get(value.id));
        else {
            // else, match strings
            const dData = this.gridView.dataSource.view();
            if (!dData.length)
                return -1;
            for (let i = 0; i < dData.length; i++)
                if (dData[i].value === value)
                    return i;
            return -1;
        }
    }
}
exports.MVPicker = MVPicker;
